import { Injectable } from '@angular/core';

import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    
} from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable() 
export class TokenInterceptor implements HttpInterceptor { 

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: string = localStorage.getItem('access_token');
        
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }
        
        if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }
        
        
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        
        return next.handle(request)
        
    }
}